import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AlertComponent } from '../core/alert/alert.component';
import type { Alert, AlertResponse, AskingAlert } from '../models/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  dialog = inject(MatDialog);

  private openAlertDialog(
    type: string,
    data: Alert | AskingAlert,
    width: string = '380px',
    cancelAble: boolean = false,
    imagePath?: string
  ): Promise<AlertResponse> {
    return new Promise((resolve) => {
      const DIALOG_REF = this.dialog.open(AlertComponent, {
        width,
        data: {
          type,
          imagePath: imagePath ? imagePath : this.getImagePath(type),
          data,
        },
        disableClose: cancelAble,
      });

      DIALOG_REF.afterClosed().subscribe((result: AlertResponse) => {
        resolve(result);
      });
    });
  }

  private getImagePath(type: string): string {
    switch (type) {
      case 'success':
        return '/icons/ic_alert_success.svg';
      case 'error':
        return '/icons/ic_alert_error.svg';
      default:
        return '';
    }
  }

  success(data: Alert): Promise<AlertResponse> {
    const DIALOG_WIDTH = data.width || '380px';
    return this.openAlertDialog('success', data, DIALOG_WIDTH, data.cancelAble);
  }

  error(data: Alert): Promise<AlertResponse> {
    const DIALOG_WIDTH = data.width || '380px';
    return this.openAlertDialog('error', data, DIALOG_WIDTH);
  }

  askAlert(data: AskingAlert, width: string = '500px', imagePath?: string): Promise<AlertResponse> {
    return this.openAlertDialog('ask', data, width, true, imagePath);
  }
}
